module.exports = __webpack_public_path__ + "static/media/KinetxLogo.bf57e7fc.svg";